import TopAppBar from '../global/TopBar';
import WebsiteSideBar from '../global/WebsiteSideBar';
import { Box, Typography, useTheme} from '@mui/material';
import { tokens } from "../../theme";


const WebsiteFrame = ({children}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box className="w-100 flex-raw" overflow={'hidden'}>
      <WebsiteSideBar />
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        flex: 1,
        minWidth: 0 // Prevents flex items from overflowing
      }}>
        <TopAppBar />
        <Box 
          sx={{ 
            flex: 1,
            overflow: 'auto',
            p: 2
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default WebsiteFrame;